import PropTypes from 'prop-types';
import { SHORTCUTS, GROUPS } from '../../game/shortcuts';

/**
 * What every key does.
 *
 * RENDERED FROM THE REGISTRY, never from a list written here. The hand-written
 * hint this replaces was already wrong one feature after it was written — it
 * omitted Shift+M, the answer keys and both admin keys. A legend maintained by
 * hand is a legend that lies, and it lies to exactly the person who needed it.
 *
 * It does NOT pause the game. This is a shared world and it keeps running while
 * you read, so this is an overlay rather than a modal.
 */
function Legend({ isAdmin, onClose }) {
  const groups = GROUPS
    .filter((g) => !g.adminOnly || isAdmin)
    .map((g) => ({ ...g, rows: SHORTCUTS.filter((s) => s.group === g.id) }))
    .filter((g) => g.rows.length > 0);

  return (
    <div className="pointer-events-auto max-h-full w-full max-w-md overflow-y-auto rounded-lg border border-gray-700 bg-gray-950/95 p-4 shadow-2xl backdrop-blur-sm">
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-semibold text-gray-100">Controls</h2>
        <button
          type="button"
          onClick={onClose}
          className="rounded px-2 text-gray-500 hover:text-gray-200"
          aria-label="Close controls"
        >
          ×
        </button>
      </div>

      {groups.map((group) => (
        <div key={group.id} className="mt-3">
          <p className="text-[10px] uppercase tracking-wide text-gray-500">{group.title}</p>
          <ul className="mt-1 space-y-1">
            {group.rows.map((s) => (
              <li key={s.id} className="flex items-baseline gap-3 text-xs">
                <kbd className="shrink-0 rounded bg-gray-800 px-1.5 py-0.5 font-mono text-[11px] text-gray-200">
                  {s.keys}
                </kbd>
                <span className="text-gray-300">
                  {s.label}
                  {s.when && <span className="text-gray-600">{` — ${s.when}`}</span>}
                </span>
              </li>
            ))}
          </ul>
        </div>
      ))}

      <p className="mt-3 text-[10px] text-gray-600">L or Esc to close</p>
    </div>
  );
}

Legend.propTypes = {
  /** Admin rows are hidden from players — they cannot use them. */
  isAdmin: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

Legend.defaultProps = { isAdmin: false };

export default Legend;
